import * as React from 'react';
import {
  ShowButton,
  List,
  Datagrid,
  TextField,
  EditButton,
  ReferenceInput,
  SelectInput,
  Filter,
  useListContext,
  TopToolbar,
  CreateButton,
  sanitizeListRestProps,
  SimpleList,
} from 'react-admin';

import { useMediaQuery } from '@material-ui/core';

const UniqueSelectInput = (props) => {
  const { choices, source } = props;

  let choices_unique = [];
  if (choices && source) {
    const choices_unique_list = choices
      .map((item) => item[source])
      .filter((value, index, self) => self.indexOf(value) === index);
    choices_unique = choices_unique_list.map((item) => {
      return { name: item, id: item };
    });
  }
  return <SelectInput choices={choices_unique} source={source} />;
};

const ProductFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput source="type" reference="products" alwaysOn>
      <UniqueSelectInput source="type" />
    </ReferenceInput>
  </Filter>
);

const ListActions = (props) => {
  const { className, exporter, filters, maxResults, ...rest } = props;
  const { basePath } = useListContext();

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      <CreateButton basePath={basePath} />
    </TopToolbar>
  );
};

export const ProductList = (props) => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <List
      title="All products"
      {...props}
      filters={<ProductFilter />}
      actions={<ListActions />}
    >
      {isSmall ? (
        <SimpleList
          primaryText={(record) => record.type}
          secondaryText={(record) => record.price}
          tertiaryText={(record) => record.num}
        />
      ) : (
        <Datagrid>
          <TextField source="id" />
          <TextField source="scenario" />
          <TextField source="type" />
          <TextField source="price" />
          <TextField source="priceUnit" />
          <TextField source="num" />
          <TextField source="purchaseType" />
          <TextField source="description" />
          <TextField source="updatedAt" />
          <EditButton />
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
